<!-- 切换 -->
<template>
  <div>
    <slot></slot>
    <div class="group p_flex p_justify_center">
      <div v-for="(item, index) in tabbar_list" @click="click_tabbar(index)" :class="tabbar_idx === index ? 'check_style' : ''" class="content_right_item p_hand p_text_center">
        <span :class="tabbar_idx === index ? 'check_dot' : ''" class="content_right_dot bg_ffffff font_12"></span>
        {{ item ? $t(item) : $parent.productName }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    tabbar_idx: {
      type: Number,
      default: 0
    },
    tabbar_list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
    click_tabbar(idx) {
      this.tabbar_idx === idx ? '' : this.$emit('callback', idx);
    }
  }
};
</script>

<style scoped="scoped">
/* tabbar */
.group {
  /* margin-top: 55px; */
  min-height: 80px;
  box-sizing: border-box;
  border-top: solid 1px #fff;
  padding-bottom: 30px;
}
.content_right_item {
  position: relative;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 800;
  width: 80px;
  padding: 14px 0 0px 0;
  transition-property: color, fontSize;
  transition: 500ms;
}
.check_style {
  color: #fff;
}
.content_right_dot {
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  transition-property: height, width;
  transition: all 500ms;
}
.check_dot {
  width: 10px;
  height: 10px;
  top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/public-switch-h5/public-switch-h5.vue